"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalFooterConfirmDismiss = ModalFooterConfirmDismiss;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("..");

var _ModalFooter = require("./ModalFooter");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ModalFooterConfirmDismiss(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement(_ModalFooter.ModalFooter, null,
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "modal__confirm-dismiss-container"
    },
    /*#__PURE__*/
    _react["default"].createElement(_.Button, {
      onClick: props.onConfirm,
      disabled: props.isConfirmDisabled
    }, props.confirmLabel),
    /*#__PURE__*/
    _react["default"].createElement(_.ButtonSecondary, {
      onClick: props.onDismiss
    }, props.dismissLabel)))
  );
}

ModalFooterConfirmDismiss.propTypes = {
  confirmLabel: _propTypes["default"].string.isRequired,
  dismissLabel: _propTypes["default"].string.isRequired,
  onConfirm: _propTypes["default"].func.isRequired,
  onDismiss: _propTypes["default"].func.isRequired,
  isConfirmDisabled: _propTypes["default"].bool
};
ModalFooterConfirmDismiss.defaultProps = {
  isConfirmDisabled: false
};